import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import axiosInstance from "../../../services/AxiosInstance";
import Api from "../../../constants/Api";
import { successAlert, warnAlert } from "../alert/defaultAlert";
import InputDecimal from "../Forms/Element/InputDecimal";
import HintTooltip from "../Common/HintTooltip";

const criteria = [
    ["customerWeight", "Clientes", "Clientes distintos com pedido no período.", 1],
    ["serviceWeight", "Serviços", "Quantidade de serviços nos pedidos, incluindo atendimentos do clube.", 2],
    ["productWeight", "Produtos", "Quantidade de produtos nos pedidos.", 3],
    ["subscriptionQuantityWeight", "Assinaturas", "Contratos cadastrados no período com o colaborador vendedor, sem cancelamento.", 4],
];
const defaults = Object.fromEntries(criteria.map(([key, , , value]) => [key, value]));

const EmployeeHighlightSetting = () => {
    const { t } = useTranslation();
    const [weights, setWeights] = useState(defaults);
    const [loading, setLoading] = useState(true);
    const [saving, setSaving] = useState(false);
    const [loadError, setLoadError] = useState(false);

    useEffect(() => {
        axiosInstance.get(Api.parameter.employeeHighlight).then(({ data }) => {
            if (data.length > 0) setWeights(Object.fromEntries(criteria.map(([key]) => [key, data[0][key] ?? defaults[key]])));
        }).catch(() => setLoadError(true)).finally(() => setLoading(false));
    }, []);

    const save = async () => {
        const data = Object.fromEntries(criteria.map(([key]) => [key, Number(weights[key])]));
        // Zero desativa um critério, mas todos zerados impediriam a escolha do destaque.
        if (criteria.some(([key]) => weights[key] === "" || weights[key] == null)
            || Object.values(data).some(value => !Number.isFinite(value) || value < 0 || value > 1000000)
            || Object.values(data).every(value => value === 0)) {
            warnAlert("Informe pesos entre 0 e 1.000.000, com pelo menos um maior que zero.");
            return;
        }
        setSaving(true);
        try {
            await axiosInstance.post(Api.parameter.employeeHighlight, data);
            successAlert(t("message.data_updated_successfully"), null);
        } catch {
            warnAlert("Não foi possível salvar os pesos. Tente novamente.");
        } finally {
            setSaving(false);
        }
    };

    return (
        <div className="card"><div className="card-body">
            <h3>Destaque do mês</h3>
            <p className="text-muted">Defina quantos pontos cada unidade vale. O maior total determina o destaque no painel de Performance e no agendamento público.</p>
            <p>A pontuação é formada pela quantidade registrada em cada critério multiplicada pelo peso definido. O colaborador com o maior total no período fica em primeiro lugar; em caso de empate, a ordem é alfabética.</p>
            {loadError && <div role="alert" className="alert alert-danger">Não foi possível carregar os pesos. Recarregue a página.</div>}
            <fieldset disabled={loading || saving || loadError}>
                <div className="row">
                    {criteria.map(([key, label, hint]) => (
                        <div className="col-md-6 mb-3" key={key}>
                            <label className="form-label" htmlFor={key}>
                                {label}: pontos por unidade
                                <HintTooltip text={hint} />
                            </label>
                            <InputDecimal id={key} name={key} value={weights[key]} onValueChange={({ value }) => setWeights(current => ({ ...current, [key]: value }))} />
                        </div>
                    ))}
                </div>
                <div className="alert alert-light">Total = clientes × {weights.customerWeight} + serviços × {weights.serviceWeight} + produtos × {weights.productWeight} + assinaturas × {weights.subscriptionQuantityWeight}</div>
                <p className="small text-muted">Os pesos pertencem à empresa e são usados no ranking do período consultado.</p>
                <button type="button" className="btn btn-primary" onClick={save}>{saving ? "Salvando…" : t("save_setting")}</button>
            </fieldset>
        </div></div>
    );
};

export default EmployeeHighlightSetting;
